module.exports = __webpack_public_path__ + "static/media/Checkbox.f9be5b92.svg";